(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-sidebar"] && !Shopify.designMode) return;
  try {
    {
  window.baesicMobileAccordion?.abort();
  const controller = new AbortController();
  window.baesicMobileAccordion = controller;
  const mobile = matchMedia('(max-width: 999px)');
  const groupOf = details => details.parentElement.closest('li')?.parentElement || details.parentElement.parentElement;
  const close = details => {
    details.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
    details.setAttribute('aria-expanded', 'false');
    details.open = false;
    details.style.height = '';
    details.style.overflow = '';
    const content = details.lastElementChild;
    if (content !== details.firstElementChild) {
      content.style.opacity = '';
      content.style.transform = '';
    }
  };
  const keepOnlySibling = details => {
    if (!mobile.matches || !details.open || details.getAttribute('aria-expanded') === 'false') return;
    const drawer = details.closest('header-sidebar');
    if (!drawer) return;
    const group = groupOf(details);
    for (const sibling of drawer.querySelectorAll('accordion-disclosure > details[open]')) {
      if (sibling !== details && groupOf(sibling) === group && !sibling.contains(details) && !details.contains(sibling)) close(sibling);
    }
  };
  document.addEventListener('click', event => {
    const summary = event.target.closest?.('header-sidebar accordion-disclosure > details > summary');
    if (summary) queueMicrotask(() => keepOnlySibling(summary.parentElement));
  }, { capture: true, signal: controller.signal });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('header-sidebar accordion-disclosure > details')) keepOnlySibling(event.target);
  }, { capture: true, signal: controller.signal });
  const normalize = () => {
    if (mobile.matches) for (const details of document.querySelectorAll('header-sidebar accordion-disclosure > details[open]')) keepOnlySibling(details);
  };
  document.addEventListener('shopify:section:load', normalize, { signal: controller.signal });
  document.addEventListener('dialog:after-show', normalize, { signal: controller.signal });
  mobile.addEventListener('change', normalize, { signal: controller.signal });
  normalize();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-starlight"] && !Shopify.designMode) return;
  try {
    {
    const HeaderStarlight = class extends HTMLElement {
      static get observedAttributes() { return ['data-density', 'data-min-brightness', 'data-max-brightness', 'data-hover-brightness', 'data-shooting-enabled', 'data-shooting-frequency', 'data-buffer', 'style']; }

      attributeChangedCallback(name, previous, value) {
        if (!this.controller || previous === value) return;
        this.readSettings();
        if (name === 'data-density') this.resize();
        this.refresh();
      }

      readSettings() {
        const number = (key, fallback, low, high) => {
          const raw = (this.owner?.isConnected ? this.owner : this).dataset[key];
          const value = raw === undefined || raw === '' ? fallback : Number(raw);
          return Math.min(high, Math.max(low, Number.isFinite(value) ? value : fallback));
        };
        this.density = number('density', 100, 25, 400) / 100;
        this.maxBrightness = number('maxBrightness', 66, 0, 100) / 100;
        this.hoverBrightness = number('hoverBrightness', 100, 0, 300) / 100;
        const shootingSource = this.owner?.isConnected ? this.owner : this;
        this.shootingEnabled = shootingSource.dataset.shootingEnabled !== 'false';
        const frequency = number('shootingFrequency', 2, 1, 30);
        if (frequency !== this.shootingFrequency) this.nextShooting = 0;
        this.shootingFrequency = frequency;
        this.minBrightness = Math.min(this.maxBrightness, number('minBrightness', 12, 0, 100) / 100);
      }

      connectedCallback() {
        if (this.controller) return;
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d', { alpha: true });
        if (!this.context) return;
        this.controller = new AbortController();
        this.dataset.runtimeVersion = '4';
        const options = { signal: this.controller.signal };
        this.header = this.owner?.header || this.closest('x-header');
        this.drawer = this.owner?.drawer || this.header.closest('.shopify-section')?.querySelector('header-sidebar') || (this.drawer?.isConnected ? this.drawer : null) || document.getElementById(this.header.querySelector('button[aria-controls="sidebar-menu"]')?.getAttribute('aria-controls'));
        this.surface = this.hasAttribute('data-panel') ? (this.panel || this.parentElement) : this.header;
        this.menuFields = new Map();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 999px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.contrast = matchMedia('(forced-colors: active)');
        this.visible = true;
        this.pointer = { x: -1000, y: -1000 };
        this.last = 0;
        this.readSettings();
        this.refresh = () => {
          if (this.boundsFrame) return;
          this.boundsFrame = requestAnimationFrame(() => { this.boundsFrame = 0; if (this.isConnected) this.sync(); });
        };
        this.rootObserver = new MutationObserver(this.refresh);
        this.rootObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-site-mode', 'data-site-reveal'] });
        this.headerObserver = new MutationObserver(this.refresh);
        this.headerObserver.observe(this.header, { attributes: true, subtree: true, childList: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-expanded', 'data-density', 'data-min-brightness', 'data-max-brightness', 'data-hover-brightness', 'data-shooting-enabled', 'data-shooting-frequency', 'data-buffer'] });
        if (this.drawer) this.headerObserver.observe(this.drawer, { attributes: true, subtree: true, childList: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-expanded', 'data-density', 'data-min-brightness', 'data-max-brightness', 'data-hover-brightness', 'data-shooting-enabled', 'data-shooting-frequency', 'data-buffer'] });
        this.resizeObserver = new ResizeObserver(() => { this.resize(); this.sync(); });
        this.controlObserver = new ResizeObserver(this.refresh);
        this.observedControls = new Set();
        this.resizeObserver.observe(this);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        });
        this.intersectionObserver.observe(this.surface);
        document.addEventListener('visibilitychange', this.refresh, options);
        document.addEventListener('shopify:section:load', this.refresh, options);
        document.addEventListener('shopify:section:reorder', this.refresh, options);
        window.addEventListener('resize', this.refresh, options);
        document.fonts?.addEventListener('loadingdone', this.refresh, options);
        this.header.addEventListener('toggle', this.refresh, { ...options, capture: true });
        this.surface.addEventListener('scroll', this.refresh, { ...options, passive: true, capture: true });
        this.scroller = this.hasAttribute('data-panel') ? this.surface.closest('.header-sidebar__scroller') : null;
        this.scroller?.addEventListener('scroll', this.refresh, { ...options, passive: true });
        for (const media of [this.motion, this.hover, this.contrast, this.mobile]) media.addEventListener('change', this.refresh, options);
        this.surface.addEventListener('pointermove', event => {
          if (!this.active || !this.hover.matches || this.mobile.matches || this.motion.matches || event.pointerType === 'touch') return;
          const rect = this.canvas.getBoundingClientRect();
          this.pointer = { x: event.clientX - rect.left, y: event.clientY - rect.top };
        }, { ...options, passive: true });
        this.surface.addEventListener('pointerleave', () => { this.pointer = { x: -1000, y: -1000 }; }, options);
        this.resize();
        this.sync();
      }

      resize() {
        const width = this.clientWidth, height = this.hasAttribute('data-panel') ? this.canvas.clientHeight : this.clientHeight;
        if (!width || !height) return;
        this.width = width;
        this.height = height;
        const scale = Math.min(devicePixelRatio || 1, 1.5, 2560 / width, 1280 / height, Math.sqrt(2097152 / (width * height)));
        this.canvas.width = Math.ceil(width * scale);
        this.canvas.height = Math.ceil(height * scale);
        this.context.setTransform(scale, 0, 0, scale, 0, 0);
        const panel = this.hasAttribute('data-panel');
        const cap = panel ? (width < 700 ? 256 : 768) : (width < 700 ? 32 : 96);
        const baseCount = Math.min(cap, Math.max(18, Math.floor(width * height / 1700)));
        const count = Math.round(baseCount * this.density);
        let seed = 7319;
        const random = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
        this.stars = Array.from({ length: count }, () => ({
          x: random() * width, y: random() * height,
          radius: .45 + random() * .55, phase: random() * Math.PI * 2,
          period: 3600 + random() * 3800, glow: 0
        }));
      }

      sync() {
        // Registered lifecycle callbacks can remain cached by the browser when
        // an editor loads an updated bundle. Reinitialize newly inserted roots
        // and panels through the current methods before drawing.
        if (!this.mobile || this.dataset.runtimeVersion !== '4') {
          this.disconnectedCallback();
          this.connectedCallback();
          return;
        }
        if (!this.hasAttribute('data-panel')) this.syncMenuFields();
        else this.anchorPanel();
        this.readSettings();
        this.active = document.documentElement.dataset.siteMode === 'night' && !document.hidden && this.visible && !this.header.classList.contains('is-hidden') && !this.contrast.matches;
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.color = getComputedStyle(this.owner?.isConnected ? this.owner : this).color;
        if (!this.active) { this.pointer = { x: -1000, y: -1000 }; this.shootingStar = null; this.nextShooting = 0; return; }
        if (!this.width) this.resize();
        this.measureExclusions();
        this.draw(this.motion.matches ? 0 : performance.now());
        if (!this.motion.matches && (this.shootingEnabled || this.maxBrightness > this.minBrightness || (this.hover.matches && !this.mobile.matches && this.hoverBrightness > this.minBrightness)) && !document.documentElement.hasAttribute('data-site-reveal')) {
          this.frame = requestAnimationFrame(time => this.tick(time));
        }
      }

      syncMenuFields() {
        // The section may connect before its drawer is parsed. Prefer its own
        // drawer over an older editor section's temporarily portaled drawer.
        const localDrawer = this.header.closest('.shopify-section')?.querySelector('header-sidebar');
        const drawer = localDrawer || (this.drawer?.isConnected ? this.drawer : null);
        if (drawer !== this.drawer) {
          this.drawer = drawer;
          if (drawer) this.headerObserver.observe(drawer, { attributes: true, subtree: true, childList: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-expanded', 'data-density', 'data-min-brightness', 'data-max-brightness', 'data-hover-brightness', 'data-shooting-enabled', 'data-shooting-frequency', 'data-buffer'] });
        }
        const wanted = new Set();
        if (document.documentElement.dataset.siteMode === 'night') {
          const panels = new Set([...this.header.querySelectorAll('.mega-menu, .header__dropdown-menu'), ...(this.drawer?.querySelectorAll('.header-sidebar__main-panel, .header-sidebar__sub-panel') || [])]);
          for (const panel of panels) {
            const drawer = panel.closest('header-sidebar');
            const rect = panel.getBoundingClientRect();
            if (wanted.size >= 4 || (drawer && !drawer.hasAttribute('open')) || !rect.width || !rect.height || panel.closest('[hidden], details:not([open])') || getComputedStyle(panel).visibility === 'hidden') continue;
            wanted.add(panel);
            let field = this.menuFields.get(panel);
            if (!field) {
              field = document.createElement('header-starlight');
              field.owner = this;
              field.panel = panel;
              field.setAttribute('data-panel', '');
              field.setAttribute('aria-hidden', 'true');
              field.inert = true;
              field.append(document.createElement('canvas'));
              if (getComputedStyle(panel).position === 'static') panel.setAttribute('data-starlight-position', '');
              panel.classList.add('starlight-panel');
              this.menuFields.set(panel, field);
            }
            for (const name of HeaderStarlight.observedAttributes.filter(name => name !== 'style')) {
              const value = this.getAttribute(name);
              if (value === null) field.removeAttribute(name);
              else if (field.getAttribute(name) !== value) field.setAttribute(name, value);
            }
            // Resolve in the header's scope: a drawer can live under <body>,
            // where inherited color variables can have different values.
            const color = getComputedStyle(this).color;
            if (field.style.getPropertyValue('--starlight-color') !== color) field.style.setProperty('--starlight-color', color);
            if (!field.isConnected) (panel.closest('.header-sidebar__collapsible-panel') || panel).prepend(field);
          }
        }
        for (const [panel, field] of this.menuFields) {
          if (wanted.has(panel)) continue;
          field.remove();
          panel.classList.remove('starlight-panel');
          panel.removeAttribute('data-starlight-position');
          this.menuFields.delete(panel);
        }
      }

      anchorPanel() {
        const panel = this.surface;
        const external = this.parentElement !== panel;
        const height = external ? this.parentElement.clientHeight : panel.clientHeight;
        // Sticky canvas is composited by the browser. Never compensate scroll
        // positions in JavaScript: that always trails asynchronous scrolling.
        const contentHeight = external ? height : panel.scrollHeight;
        const stickyTop = external ? 0 : -(parseFloat(getComputedStyle(panel).paddingTop) || 0);
        for (const [name, value] of [['--starlight-content-height', `${contentHeight}px`], ['--starlight-panel-height', `${height}px`], ['--starlight-sticky-top', `${stickyTop}px`]]) {
          if (this.style.getPropertyValue(name) !== value) this.style.setProperty(name, value);
        }
      }

      measureExclusions() {
        const origin = this.canvas.getBoundingClientRect();
        const buffer = Math.min(24, Math.max(4, Number(this.dataset.buffer) || 10));
        this.exclusions = [];
        const controls = new Set();
        if (this.mobile.matches) {
          for (const control of this.observedControls) this.controlObserver.unobserve(control);
          this.observedControls = controls;
          return;
        }
        for (const control of this.surface.querySelectorAll('a, button, summary, input, select, [role="button"], [data-vehicle-mode-toggle], [tabindex]:not([tabindex="-1"])')) {
          if (control.closest('header-starlight')) continue;
          if (!this.hasAttribute('data-panel') && control.closest('.mega-menu, .header__dropdown-menu, header-sidebar')) continue;
          const rect = control.getBoundingClientRect();
          if (!rect.width || !rect.height || rect.bottom <= origin.top || rect.top >= origin.bottom || rect.right <= origin.left || rect.left >= origin.right || getComputedStyle(control).visibility === 'hidden') continue;
          this.exclusions.push({ left: rect.left - origin.left - buffer, top: rect.top - origin.top - buffer, right: rect.right - origin.left + buffer, bottom: rect.bottom - origin.top + buffer });
          controls.add(control);
          if (!this.observedControls.has(control)) this.controlObserver.observe(control);
        }
        for (const control of this.observedControls) if (!controls.has(control)) this.controlObserver.unobserve(control);
        this.observedControls = controls;
      }

      tick(time) {
        if (!this.active || !this.isConnected) { this.frame = 0; return; }
        if (this.motion.matches || document.hidden || this.contrast.matches || document.documentElement.hasAttribute('data-site-reveal')) { this.sync(); return; }
        if (time - this.last >= 50) { this.draw(time); this.last = time; }
        this.frame = requestAnimationFrame(next => this.tick(next));
      }

      draw(time) {
        if (!this.stars) return;
        const ctx = this.context;
        ctx.clearRect(0, 0, this.width, this.height);
        ctx.fillStyle = this.color;
        for (const star of this.stars) {
          const halo = star.radius * 7.5 + 1;
          if (this.exclusions?.some(rect => star.x + halo >= rect.left && star.x - halo <= rect.right && star.y + halo >= rect.top && star.y - halo <= rect.bottom)) { star.glow = 0; continue; }
          const distance = Math.hypot(star.x - this.pointer.x, star.y - this.pointer.y);
          const target = this.hover.matches && !this.mobile.matches && !this.motion.matches ? Math.max(0, 1 - distance / 110) : 0;
          if (this.motion.matches || this.mobile.matches || !this.hover.matches) star.glow = 0;
          else star.glow += (target - star.glow) * .18;
          const pulse = this.motion.matches ? .5 : (Math.sin(time / star.period * Math.PI * 2 + star.phase) + 1) / 2;
          const normal = this.minBrightness + (this.maxBrightness - this.minBrightness) * pulse;
          const brightness = normal + Math.max(0, this.hoverBrightness - normal) * star.glow;
          const alpha = Math.min(1, brightness);
          const bloom = Math.max(0, brightness - 1);
          ctx.fillStyle = this.color;
          ctx.globalAlpha = Math.min(.5, alpha * .12 + bloom * .18);
          ctx.beginPath(); ctx.arc(star.x, star.y, star.radius * (3.5 + bloom * 2), 0, Math.PI * 2); ctx.fill();
          ctx.globalAlpha = alpha;
          ctx.beginPath(); ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2); ctx.fill();
          if (bloom > 0) {
            ctx.fillStyle = '#fff'; ctx.globalAlpha = Math.min(1, bloom * .5);
            ctx.beginPath(); ctx.arc(star.x, star.y, star.radius * .65, 0, Math.PI * 2); ctx.fill();
          }
        }
        this.drawShooting(time);
        ctx.globalAlpha = 1;
        for (const rect of this.exclusions || []) ctx.clearRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top);
      }

      drawShooting(time) {
        if (!this.shootingEnabled || this.motion.matches || !this.active) {
          this.shootingStar = null;
          this.nextShooting = 0;
          return;
        }
        if (!this.nextShooting) this.nextShooting = time + 60000 / this.shootingFrequency * (.75 + Math.random() * .5);
        if (!this.shootingStar && time >= this.nextShooting) {
          this.shootingStar = { start: time, x: this.width * (.1 + Math.random() * .55), y: this.height * (.1 + Math.random() * .45) };
          this.nextShooting = time + 60000 / this.shootingFrequency * (.75 + Math.random() * .5);
        }
        const star = this.shootingStar;
        if (!star) return;
        const progress = (time - star.start) / 1000;
        if (progress >= 1) { this.shootingStar = null; return; }
        const dx = Math.min(240, this.width * .4), dy = Math.min(90, this.height * .35);
        const x = star.x + progress * dx, y = star.y + progress * dy;
        const fade = Math.sin(progress * Math.PI) * .35;
        const ctx = this.context;
        ctx.strokeStyle = this.color;
        ctx.lineWidth = 1;
        ctx.lineCap = 'round';
        for (let segment = 0; segment < 12; segment++) {
          const tail = segment / 12 * .3;
          ctx.globalAlpha = fade * (1 - segment / 12);
          ctx.beginPath();
          ctx.moveTo(x - dx * tail, y - dy * tail);
          ctx.lineTo(x - dx * (tail + .025), y - dy * (tail + .025));
          ctx.stroke();
        }
      }

      disconnectedCallback() {
        for (const [panel, field] of this.menuFields || []) {
          field.remove();
          panel.classList.remove('starlight-panel');
          panel.removeAttribute('data-starlight-position');
        }
        this.menuFields?.clear();
        this.shootingStar = null;
        this.nextShooting = 0;
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.boundsFrame);
        this.boundsFrame = 0;
        this.frame = 0;
        this.controller?.abort();
        this.controller = null;
        for (const observer of [this.rootObserver, this.headerObserver, this.resizeObserver, this.intersectionObserver, this.controlObserver]) observer?.disconnect();
      }
    };
    const ExistingStarlight = customElements.get('header-starlight');
    if (!ExistingStarlight) {
      customElements.define('header-starlight', HeaderStarlight);
    } else {
      // An editor can retain the original custom-element class after loading
      // updated theme JavaScript. Upgrade that class and reconnect its roots.
      const roots = [...document.querySelectorAll('header-starlight:not([data-panel])')];
      roots.forEach(root => root.disconnectedCallback());
      const methods = Object.getOwnPropertyDescriptors(HeaderStarlight.prototype);
      delete methods.constructor;
      Object.defineProperties(ExistingStarlight.prototype, methods);
      roots.filter(root => root.isConnected).forEach(root => root.connectedCallback());
    }
  }
  } catch(e) { console.error(e); }
})();

})();
